import axios from "axios";

//IMPORT API ROUTE URL
import { REMOVE_CLIENT_ACCESS_ROUTE } from "./apiRoutes";

const removeClientAccess = (data) => {
  var postData = new FormData();

  postData.append("user_slug", data.user_slug);
  postData.append("relation_id", data.relation_id);

  return axios
    .post(REMOVE_CLIENT_ACCESS_ROUTE, postData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default removeClientAccess;
